import { render, staticRenderFns } from "./Pos_monitor.vue?vue&type=template&id=06245998&scoped=true&"
import script from "./Pos_monitor.vue?vue&type=script&lang=js&"
export * from "./Pos_monitor.vue?vue&type=script&lang=js&"
import style0 from "./Pos_monitor.vue?vue&type=style&index=0&id=06245998&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06245998",
  null
  
)

export default component.exports